import { IPickLight } from "core-integration/src/store/entries/types";
import { usePlosTranslations } from "../../contexts/PlosTranslationsContext";
import Captain from "../../img/icons/captain.svg?react";
import ViceCaptain from "../../img/icons/vice-captain.svg?react";
import { captainStyles, tripleCaptainStyles } from "./captainIcon.css";

interface CaptainIconProps {
  chipName?: string;
  pick: IPickLight;
  "aria-hidden"?: boolean;
}

export const CaptainIcon = ({
  chipName,
  pick,
  "aria-hidden": ariaHidden,
}: CaptainIconProps) => {
  const { captain: captainText, viceCaptain: viceCaptainText } =
    usePlosTranslations();
  if (!pick.is_captain && !pick.is_vice_captain) {
    return null;
  }

  const Icon = pick.is_captain ? Captain : ViceCaptain;
  const label = pick.is_captain ? captainText : viceCaptainText;
  const hasTripleCaptain = chipName === "3xc";

  return (
    <Icon
      aria-label={ariaHidden ? undefined : label}
      role={ariaHidden ? "presentation" : "img"}
      aria-hidden={ariaHidden}
      className={hasTripleCaptain ? tripleCaptainStyles : captainStyles}
    />
  );
};
